<section fxLayout="row" fxLayoutAlign="space-between baseline" fxLayoutGap="16px">
    <mat-card fxFlex>
        <img mat-card-image src="assets\images\training-load-snapshot.PNG" />
        <mat-card-title>Training Load Analysis</mat-card-title>
        <mat-card-content>
            Poor training load management is one of many established risk factors of overuse MSIs. Routine monitoring of training load can identify Marines who are at an increased risk of injury.
        </mat-card-content>
        <mat-card-actions>
            <button mat-button (click)="openReport('training-load-analysis')">LAUNCH</button>
        </mat-card-actions>
    </mat-card>
    <mat-card fxFlex>
        <img mat-card-image src="assets\images\planning.png" />
        <mat-card-title>PFT/CFT Scores</mat-card-title>
        <mat-card-content>
            The PFT is used to evaluate overall physical fitness, while the CFT is used to make sure Marines are physically ready for combat. Routine monitoring can help assess the readiness of a unit or individual.
        </mat-card-content>
        <mat-card-actions>
            <button mat-button (click)="openReport('pft-cft-scores')">LAUNCH</button>
        </mat-card-actions>
    </mat-card>
</section>
